module.exports = __webpack_public_path__ + "img/chevron-down-gray.abffeecb.svg";